import React, { useState } from 'react';

function UpdateCoinsWon() {
  const [email, setEmail] = useState('');
  const [coinsWonToAdd, setCoinsWonToAdd] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !coinsWonToAdd) {
      setMessage('Please fill all fields');
      return;
    }

    try {
      const response = await fetch('https://backend.aubattle.com/api/coins/update-coins-won', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, coinsWonToAdd: Number(coinsWonToAdd) }),
      });

      const data = await response.json();
      setMessage(data.message || 'Updated successfully');
      setEmail('');
      setCoinsWonToAdd('');
    } catch (error) {
      setMessage('Error updating coins won');
    }
  };

  return (
    <div>
      <h2>Update Coins Won</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="User Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="number"
          placeholder="Coins Won to Add"
          value={coinsWonToAdd}
          onChange={(e) => setCoinsWonToAdd(e.target.value)}
          required
          min="1"
        />
        <button type="submit">Update</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default UpdateCoinsWon;
